<template>
  <header class="simple-header">
    <div class="simple-header__inner">
      <div class="simplehead-tit">
        <div class="simplehead-tit__logo"><a target="_blank" href="https://www.his-j.com/Default.aspx" class="simple-header__logo simple-header__logo--his" rel="noopener"></a></div>
        <div class="simplehead-tit__tit">{{ title }}</div>
      </div>
    </div>
  </header>
</template>
<script>
export default {
  props: {
    title: String,
  }
}
</script>

<style scoped>
.simple-header {
  background: #0057B8;
}

.simple-header__inner {
  margin-left: auto;
  margin-right: auto;
}

.simple-header__logo {
  display: block;
  background-repeat: no-repeat;
  z-index: 1;
}

.simple-header__logo--his {
  background: url(https://www.his-j.com/cmn/images/his_logo_white.svg) no-repeat center;
}
.simple-header__inner {
  max-width: 992px;
  padding: 16px 0;
}
.simplehead-tit {
  display: -webkit-flex;
  display: flex;
  -webkit-box-pack: start;
  justify-content: flex-start;
  -webkit-box-align: center;
  align-items:  center;
}
.simplehead-tit__logo {
  flex-basis: 68px;
  height: 27px;
  flex-shrink: 0;
  margin-right: 16px;
}
.simplehead-tit__tit {
  font-size: 14px;
  font-weight: bold;
  line-height: 1;
  color: #fff;
}

.simple-header__logo--his {
  display: block;
  width: 68px;
  height: 27px;
}

@media screen and (max-width: 1023px) {
  .simple-header__inner {
    width: auto;
  }
}
@media screen and (max-width: 991px) {
  .simple-header__inner {
    max-width: 91.46666%;
  }
}
@media screen and (max-width: 767px) {
  .simple-header__inner {
    width: auto;
    padding: 12px 0 12px;
  }
  .simplehead-tit__tit {
    font-size: 13px;
  }
}
</style>
